import React from "react";
import "./App.scss";
import MultipleFlexListSlider from "./component/MultipleFlexListSlider/MultipleFlexListSlider";
import SummaryCard from "./component/SummaryCard/SummaryCard";
import { metricDefsData } from "./component/SummaryCard/SummaryCard.fixtures";
import { Tooltip } from "./component/ui-component/tooltip/Tooltip";
import { CustomizedMetaCard } from "./component/zComponents/CustomizedMetaCard/CustomizedMetaCard";
import { IComponentInfo, TComponentName, TDateTimeMode } from "./types/index";
type TAppProps = {
	componentInfo: IComponentInfo;
	timeMode: TDateTimeMode;
};

const App: React.FC<TAppProps> = ({ componentInfo, timeMode }) => {
	console.log({ componentInfo });
	return (
		<div className="react-component">
			{(() => {
				// TODO: Check if switch case is required here
				switch (componentInfo.type) {
					case "MO-WGT-CUSTOMIZED-DATA-LIST": {
						return (
							<SummaryCard
								timeMode={timeMode}
								componentInfo={componentInfo}
							/>
						);
					}

					case "MO-WGT-CUSTOMIZED-META-CARD": {
						const config = componentInfo.config.args.options;
						return (
							<CustomizedMetaCard
								config={config as any}
								data={componentInfo.data}
							/>
						);
					}

					case "MO-WGT-MULTIPLE-FLEX-LIST-SLIDER": {
						return (
							<MultipleFlexListSlider
								config={componentInfo.config}
								data={componentInfo.data}
								timeMode={timeMode}
							/>
						);
					}

					default:
						return (
							<Tooltip metricDefinition={metricDefsData}>
								<span>Hover on</span>
							</Tooltip>
						);
				}
			})()}
		</div>
	);
};

export default App;

const x = {
	id: "0.4538100516544312",
	type: "MO-WGT-CUSTOMIZED-DATA-LIST" as TComponentName,
	data: {
		data: [
			{
				trend_threshold: null,
				variance: null,
			},
		],
	},
	config: {
		args: {
			options: {
				type: "production_overview",
				columns: [
					{
						name: "Planned Target",
						prop: "planned_target",
						sub: false,
						indicator: false,
						past_visibility: true,
						metricDefinition: {
							header: "Production Overview",
							subHeader: "Total no. of FTT garments",
							definition:
								"Total number of garment pieces that are approved at the end-line QC at the first attempt",
						},
					},
					{
						name: "RTT",
						prop: "rtt",
						sub: false,
						indicator: false,
						past_visibility: false,
						metricDefinition: {
							header: "RTT",
							subHeader: "Total no. of FTT garments",
							definition:
								"Total number of garment pieces that are approved at the end-line QC at the first attempt",
						},
					},
					{
						name: "Actual Production",
						prop: "actual_production",
						sub: false,
						indicator: false,
						past_visibility: true,
						metricDefinition: {
							header: "Actual Production",
							subHeader: "Total no. of FTT garments",
							definition:
								"Total number of garment pieces that are approved at the end-line QC at the first attempt",
						},
					},
					{
						name: "Variance",
						prop: "variance",
						sub: false,
						indicator: true,
						threshold: "variance",
						subheading: "vs RTT",
						subheading2: "vs Planned",
						past_visibility: true,
						dynamic_sub_name: true,
						compared_attribute: "actual_production",
						dynamic_attribute1: "rtt",
						dynamic_attribute2: "planned_target",
						threshold_type: "plus_minus",
						upper_threshold_color: "vlue-ind-green",
						lower_threshold_color: "vlue-ind-red",
						metricDefinition: {
							header: "Variance",
							subHeader: "Total no. of FTT garments",
							definition:
								"Total number of garment pieces that are approved at the end-line QC at the first attempt",
						},
					},
					{
						name: "Predicted Trend",
						prop: "trend",
						sub: true,
						indicator: true,
						threshold: "trend_threshold",
						subheading: "vs Planned",
						dynamic_sub_prop: false,
						past_visibility: false,
						threshold_type: "plus_minus",
						upper_threshold_color: "vlue-l2-ind-green",
						lower_threshold_color: "vlue-l2-ind-red",
						metricDefinition: {
							header: "Predicted Trend",
							subHeader: "Total no. of FTT garments",
							definition:
								"Total number of garment pieces that are approved at the end-line QC at the first attempt",
						},
					},
					{
						name: "WIP",
						prop: "wip",
						indicator: false,
						past_visibility: false,
					},
				],
			},
		},
		name: "mo-wgt-customized-data-list",
		data_attribute_name: "model",
		data_model_type: "WebSocketDataModel",
		data_model_args: {
			req_id: "quick_statistics_trend_wip_request_v2",
			req_args: [
				{
					key: "@ds",
					value: "ds5_analytics",
				},
				{
					key: "@subject_splitter",
					value: 6,
				},
				{
					key: "@time_block1",
					value: "@time_block1",
				},
				{
					key: "@time_block2",
					value: "@time_block2",
				},
				{
					key: "@checked_pcs",
					value: "checked_pcs_m1",
				},
				{
					key: "@granularity",
					value: "all",
				},
				{
					key: "@plan_name",
					value: "production_plan",
				},
				{
					key: "@wip_type",
					value: ["sewing_line"],
				},
				{
					key: "@start_date",
					value: "2021-11-29",
				},
				{
					key: "@end_date",
					value: "2021-11-29",
				},
				{
					key: "@subject_key",
					value: "ind-pemp-p122",
				},
				{
					key: "@display_name",
					value: "tenant_id",
				},
				{
					key: "@session_dates",
					value: "2021-11-29",
				},
				{
					key: "@time_block",
					value: "sessionDate",
				},
				{
					key: "@subjects_filter",
					value: "regex",
				},
				{
					key: "@subjects",
					value: "ind-pemp-p122-plant1-floor.*-sewing-.*",
				},
				{
					key: "@display_name_filter",
					value: true,
				},
				{
					key: "@window",
					value: "2021-11-29T00:00:00.000Z/2021-11-29T23:59:59.999Z",
				},
			],
		},
		navigation: [],
	},
};
